import { startCase } from "lodash";

export const createOptionsFromEnumArray = <T extends string>(
  enumArray: readonly T[],
  keepLabelCase: boolean = false,
) => {
  return enumArray.map((enumValue) => ({
    label: keepLabelCase ? enumValue : startCase(enumValue.toLowerCase()),
    value: enumValue,
  }));
};
